import React from 'react';
import { EditorAffiliation } from 'app/blocks/article-affiliations-editor/utils';
import AffiliationsTooltip from '../AffiliationsTooltip/AffiliationsTooltip';

type AffiliationValueProps = {
    readonly affiliations: EditorAffiliation[];
    readonly l: l;
    readonly seleniumid: string;
    readonly showAllInline?: boolean;
};

export function getAffiliationValue({
    affiliations,
    l,
    seleniumid,
    showAllInline,
}: AffiliationValueProps): React.ReactNode {
    const discountedAffiliations = affiliations.filter(i => i.eligibleForInstitutionalDiscount);
    const selectedAffiliations = discountedAffiliations.length > 0 ? discountedAffiliations : affiliations;
    const [firstAffiliation, ...restAffiliations] = selectedAffiliations;

    if (!firstAffiliation) {
        return l('ARTICLE_AFFILIATION_EDITOR.CONFIRM_PRICE_CHANGE_NO_AFFILIATION');
    }

    if (selectedAffiliations.length === 1) {
        return firstAffiliation?.institutionName || '';
    }

    const moreCount = selectedAffiliations.length - 1;
    const tooltipAffiliations = restAffiliations.map(a => a.institutionName);

    return React.createElement(AffiliationsTooltip, {
        firstAffiliationName: firstAffiliation?.institutionName || '',
        l,
        moreCount,
        seleniumid,
        showAllInline,
        tooltipAffiliations,
    });
}

export function getPrimaryInstitutionName(
    eligibleAffiliations: EditorAffiliation[],
    selectedPrimaryAffiliationId?: string,
): string | undefined {
    if (eligibleAffiliations.length === 1) {
        return eligibleAffiliations[0]?.institutionName;
    }

    const selectedPrimaryAffiliation = eligibleAffiliations.find(a => a.affiliationId === selectedPrimaryAffiliationId);
    return selectedPrimaryAffiliation?.institutionName;
}
